import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Trash2, Plus, Ban } from "lucide-react";
import { toast } from "sonner";

export default function AdminRestricted() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ pincode: "", reason: "" });
  const load = () => api.get("/admin/restricted-pincodes").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/restricted-pincodes", form);
      toast.success("Restricted pincode added");
      setForm({ pincode: "", reason: "" });
      load();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };
  const del = async (r) => {
    if (!window.confirm(`Remove restriction on ${r.pincode}?`)) return;
    await api.delete(`/admin/restricted-pincodes/${r.id}`);
    load();
  };

  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold flex items-center gap-2">
        <Ban className="w-6 h-6 text-hyd-red" /> Restricted pincodes
      </h1>
      <p className="text-hyd-text2 text-sm">Block delivery to pincodes where fireworks sale is legally restricted.</p>

      <form onSubmit={submit} className="mt-5 bg-hyd-panel border border-hyd-border rounded-xl p-4 grid sm:grid-cols-3 gap-3 items-end">
        <div>
          <Label className="text-xs text-hyd-text2 mb-1 block">Pincode</Label>
          <Input value={form.pincode} onChange={(e) => setForm({ ...form, pincode: e.target.value.replace(/\D/g, "").slice(0, 6) })} className="bg-hyd-bg border-hyd-border" maxLength={6} required />
        </div>
        <div className="sm:col-span-2">
          <Label className="text-xs text-hyd-text2 mb-1 block">Reason</Label>
          <Input value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} className="bg-hyd-bg border-hyd-border" placeholder="e.g. Supreme Court restriction" />
        </div>
        <Button type="submit" className="bg-hyd-gold text-hyd-bg hover:bg-hyd-goldDim font-bold sm:col-span-3"><Plus className="w-4 h-4 mr-1" /> Add restriction</Button>
      </form>

      <div className="mt-5 bg-hyd-panel border border-hyd-border rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-hyd-panel2 text-hyd-text2 text-xs uppercase tracking-widest">
            <tr><th className="text-left p-3">Pincode</th><th className="text-left p-3">Reason</th><th className="p-3"></th></tr>
          </thead>
          <tbody className="divide-y divide-hyd-border">
            {rows.map((r) => (
              <tr key={r.id}>
                <td className="p-3 font-mono">{r.pincode}</td>
                <td className="p-3 text-hyd-text2">{r.reason || "—"}</td>
                <td className="p-3 text-right"><Button variant="ghost" size="sm" onClick={() => del(r)} className="text-hyd-red hover:bg-hyd-panel"><Trash2 className="w-3.5 h-3.5" /></Button></td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows.length === 0 && <div className="p-8 text-center text-hyd-text3">No restrictions yet. Delhi (110xxx) is blocked by default.</div>}
      </div>
    </div>
  );
}
